import { RootState } from 'models';

const getOptionsFilterPreference = (state: RootState) => state.userReportSettings.optionsFilterPreference;

const getSelectedFilterPreference = (state: RootState) => state.userReportSettings.selectedFilterPreference;

export default {
  getOptionsFilterPreference,
  getSelectedFilterPreference,
};
